import { Color } from "three";

export const lerp = (start, end, factor) => {
    return start + (end - start) * factor;
}

export const lerpColor = (color1, color2, factor) => {
    const c1 = new Color(color1);
    const c2 = new Color(color2);

    return c1.lerp(c2, factor);
}